import type { IconProps } from './types';
import './icons.css';

export default function Up({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 10}
      height={height || 7}
      viewBox="0 0 10 7"
      className={`icon icon-up ${className || ''}`}
      fill="none"
    >
      <path d="M1 6L5 2L9 6" stroke="currentColor" />
    </svg>
  );
}
